import React, { useState, useRef } from "react";

const DateTimeInput = ({ value, onChange }) => {
  const dateTimeInputRef = useRef(null);
  const [inputValue, setInputValue] = useState(value || "");

  const formatDisplayDateTime = (dateTimeString) => {
    if (!dateTimeString) return "";

    // 숫자만 추출
    const numbers = dateTimeString.replace(/\D/g, "");

    if (numbers.length === 12) {
      // 12자리 숫자를 날짜 형식으로 변환
      const year = numbers.substring(0, 4);
      const month = numbers.substring(4, 6);
      const day = numbers.substring(6, 8);
      const hour = numbers.substring(8, 10);
      const minute = numbers.substring(10, 12);

      return `${year}-${month}-${day} ${hour}:${minute}`;
    }

    return numbers;
  };

  const handleNumberInput = (e) => {
    const numbers = e.target.value.replace(/\D/g, "");
    setInputValue(numbers);

    if (numbers.length === 12) {
      const year = numbers.substring(0, 4);
      const month = numbers.substring(4, 6);
      const day = numbers.substring(6, 8);
      const hour = numbers.substring(8, 10);
      const minute = numbers.substring(10, 12);

      // 날짜 유효성 검사
      const date = new Date(year, month - 1, day, hour, minute);
      if (
        date.getFullYear() === parseInt(year) &&
        date.getMonth() === parseInt(month) - 1 &&
        date.getDate() === parseInt(day) &&
        date.getHours() === parseInt(hour) &&
        date.getMinutes() === parseInt(minute)
      ) {
        // 유효한 날짜인 경우 ISO 형식으로 변환
        const formattedDateTime = `${year}-${month}-${day}T${hour}:${minute}`;
        onChange(formattedDateTime);
      }
    }
  };

  const handleCalendarClick = () => {
    if (dateTimeInputRef.current) {
      dateTimeInputRef.current.showPicker();
    }
  };

  const handleDateTimeSelect = (e) => {
    const selectedDateTime = e.target.value;
    if (selectedDateTime) {
      const formattedValue = selectedDateTime.replace(/[-:T]/g, "");
      setInputValue(formattedValue);
      onChange(selectedDateTime);
    }
  };

  return (
    <div className="datetime-container">
      <div className="datetime-wrapper">
        <input
          type="text"
          value={formatDisplayDateTime(inputValue)}
          onChange={handleNumberInput}
          placeholder="YYYYMMDDHHmm"
          maxLength="16"
          className="datetime-input"
        />
        <button
          type="button"
          className="datetime-calendar-button"
          onClick={handleCalendarClick}
          aria-label="달력 열기"
        >
          <svg
            className="datetime-calendar-icon"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
        </button>
        <input
          ref={dateTimeInputRef}
          type="datetime-local"
          value={value || ""}
          onChange={handleDateTimeSelect}
          className="datetime-calendar-input"
          style={{
            opacity: 0,
            position: "absolute",
            width: "1px",
            height: "1px",
          }}
        />
      </div>
    </div>
  );
};

export default DateTimeInput;
